import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import LinkPicker from './LinkPicker.js';
import AlignPicker from './AlignPicker.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';
import FontPicker from './FontPicker.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class ShippingTracker extends React.Component {
    constructor(props) {
        super(props);
        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);

        this.items = this.items.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.onButtonChange = this.onButtonChange.bind(this);

    }

    onButtonChange(e) {
        this.props.setComponentState(this.el().id,{'button_text':e.target.value});
    }

    handleChange(id,s) {
        let changes = {};
        changes[id] = s;
        this.props.setComponentState(this.el().id,changes);
    }

    el() {
        return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
        this.props.setSidebarState({'visible':false});
    }

    items() {
        let lines = [];
        const products = [
            {
                'id':1,
                'time':'2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': '',
            },
            {
                'id':2,
                'time':'2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': '',
            },
            {
                'id':3,
                'time':'2018-02-21 11:46',
                'description': 'E-mail notification has been sent to the recipient ',
                'location': '',
            },
            {
                'id':4,
                'time':'2018-02-21 11:46',
                'description': 'The electronic shipping instructions have been received',
                'location': 'Oslo',
            },
        ];

        products.map((item) => {
            lines.push(
                <tr key={item.id}>
                    <td className="table-width-20 table-top" style={{padding:'10px'}}>
                        {this.col(item.time)}
                    </td>
                    <td className="table-width-60 table-top" style={{padding:'10px'}}>
                        {this.col(item.description)}
                    </td>
                    <td className="table-width-20" style={{padding:'10px'}}>
                        {this.col(item.location)}
                    </td>
                </tr>
            );
        });

        return lines;
    }

    col(text) {
        return (
            <table style={{verticalAlign:'top',width:'100%'}}>
                <tbody>
                <tr>
                    <td>
                        {text}
                    </td>
                </tr>
                </tbody>
            </table>
        )
    }

    componentDidMount() {

    }

    render() {


        if(this.props.sidebar == true) {
            return(
                <div className="sidebar text" style={this.props.style}>
                    <SidebarElementHeader handleBackClick={this.handleBackClick} text="Shipping tracker" />

                    <div className="panel-group panel-group-continuous" id="cart-settings" aria-multiselectable="true" role="tablist">


                        <SidebarSettingAccordion selectedSetting={false} optionKey="button" parent="cart-settings" title="Settings">
                            <SidebarElementSetting text="Header text">
                                <input type="text" value={this.el().text_package_tracking} onChange={(e) => {this.handleChange('text_package_tracking',e.target.value)}} className="form-control" />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Button text">
                                <input type="text" value={this.el().text_package_tracking_button} onChange={(e) => {this.handleChange('text_package_tracking_button',e.target.value)}} className="form-control" />
                            </SidebarElementSetting>

                            <SidebarElementSetting text="Primary color">
                                <ColorPicker id='primary_color' color={this.el().primary_color} handleColorChange={this.handleChange} />
                            </SidebarElementSetting>

                        </SidebarSettingAccordion>
                    </div>


                </div>


            );
        }else{
            let button_style = {
                backgroundColor:this.el().primary_color
            };
            return (
                <table className="shipping-tracker table-block" style={{width:'100%'}}>
                    <tbody>
                    <tr>
                        <td>
                            <table style={{width:'100%',backgroundColor:this.el().primary_color,color:'#fff'}}>
                                <tbody>
                                <tr>
                                    <td style={{textAlign:'left',padding:'10px'}}>{this.el().text_package_tracking} - @@SHIPPING_PROVIDER@@ ( @@TRACKING_NUMBER@@ )</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table className="tracker table-block">
                                <tbody>
                                {this.items()}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    {
                        this.el().text_package_tracking_button != '' ?
                            <tr>
                                <td>
                                    <table className="table-block" style={{width:'100%',marginTop:'15px'}}>
                                        <tbody>
                                        <tr>
                                            <td style={{textAlign:'center'}}>
                                                <a className="click-button"  style={button_style}  href="javascript:void(0)">{this.el().text_package_tracking_button}</a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>:null
                    }

                    </tbody>
                </table>

            );
        }

    }
}
const mapStateToProps = (state) => {
    return {
        builder:state.builder
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

ShippingTracker = connect(mapStateToProps,mapDispatchToProps)(ShippingTracker);

export default ShippingTracker;





// WEBPACK FOOTER //
// ./components/builder/ShippingTracker.js